<template>
   <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path d="M3.92 16.5L2 14.58L10.06 6.5L12 8.44M17.71 3.13L15.37 0.789998C15 0.399998 14.35 0.399998 13.96 0.789998L10.84 3.91L8.91 2L7.5 3.41L8.92 4.83L0 13.75V18.5H4.75L13.67 9.58L15.09 11L16.5 9.59L14.58 7.67L17.7 4.55C18.1 4.15 18.1 3.5 17.71 3.13Z" fill="black"/>
   </svg>
</template>
<script>
    export default {
	    name: 'ColorIconSVG'
    }
</script>

